var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49999 13.334L9.99999 10.834M9.99999 10.834L12.5 13.334M9.99999 10.834V16.6673M18.3333 7.50065H1.66666M4.58332 15.0006H4.33332C3.3999 15.0006 2.93319 15.0006 2.57667 14.819C2.26307 14.6592 2.0081 14.4042 1.84831 14.0906C1.66666 13.7341 1.66666 13.2674 1.66666 12.334V6.00065C1.66666 5.06723 1.66666 4.60052 1.84831 4.244C2.0081 3.9304 2.26307 3.67543 2.57667 3.51564C2.93319 3.33398 3.3999 3.33398 4.33332 3.33398H15.6667C16.6001 3.33398 17.0668 3.33398 17.4233 3.51564C17.7369 3.67543 17.9919 3.9304 18.1517 4.244C18.3333 4.60052 18.3333 5.06723 18.3333 6.00065V12.334C18.3333 13.2674 18.3333 13.7341 18.1517 14.0906C17.9919 14.4042 17.7369 14.6592 17.4233 14.819C17.0668 15.0007 16.6001 15.0007 15.6667 15.0007H15.4167",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.22ea4719b9204803b0afcd3bff9931eb.svg";
export { ForwardRef as ReactComponent };